import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout, updateLastActivity, checkUserAuthorization } from '../../store/authSlice';

const INACTIVITY_TIMEOUT = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

const PrivateRoute = ({ children }) => {
  const dispatch = useDispatch();
  const { 
    isAuthenticated, 
    lastActivityTimestamp, 
    isAuthorized 
  } = useSelector((state) => state.auth);
  const token = localStorage.getItem('token');

  // Check authorization periodically
  useEffect(() => {
    if (isAuthenticated && token) {
      dispatch(checkUserAuthorization());
    }
  }, [isAuthenticated, token, dispatch]);

  // Inactivity timeout logic
  useEffect(() => {
    if (isAuthenticated && lastActivityTimestamp) {
      const currentTime = Date.now();
      const timeSinceLastActivity = currentTime - lastActivityTimestamp;

      // If inactive for more than 24 hours, log out
      if (timeSinceLastActivity > INACTIVITY_TIMEOUT) {
        dispatch(logout());
        localStorage.removeItem('token');
      }
    }
  }, [isAuthenticated, lastActivityTimestamp, dispatch]);

  // Activity tracking
  useEffect(() => {
    const trackActivity = () => {
      dispatch(updateLastActivity());
    };

    // Add event listeners for user activity
    window.addEventListener('mousemove', trackActivity);
    window.addEventListener('keydown', trackActivity);
    window.addEventListener('click', trackActivity);

    // Cleanup event listeners
    return () => {
      window.removeEventListener('mousemove', trackActivity);
      window.removeEventListener('keydown', trackActivity);
      window.removeEventListener('click', trackActivity);
    };
  }, [dispatch]);

  // Check for authentication and authorization
  if (!token || !isAuthenticated || !isAuthorized) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;